module.exports = __webpack_public_path__ + "img/alert-icon.d06492d8.svg";